import React, {useReducer} from "react";
import {createContext} from "react";

export const SideMenuContext = createContext(null);

const initialState = {
  outerIndex: -1,
  openSchema: -1,
  openMenu: 0,
  openSubMenu: -1,
  activeState: -1
};

const sideMenuReducer = (state, action) => {
  const {type, payload} = action;
  switch (type) {
  case "UPDATE_OUTERINDEX":
    return {...state, outerIndex: payload};
  case "UPDATE_OPENSCHEMA":
    return {...state, openSchema: payload};
  case "UPDATE_OPENMENU":
    return {...state, openMenu: payload};
  case "UPDATE_OPENSUBMENU":
    return {...state, openSubMenu: payload};
  case "UPDATE_ACTIVESTATE":
    return {...state, activeState:payload};
  }
};

export const createOuterIndexAction = (payload) => ({type: "UPDATE_OUTERINDEX", payload});
export const createOpenSchemaAction = (payload) => ({type: "UPDATE_OPENSCHEMA", payload});
export const createOpenMenuAction = (payload) => ({type: "UPDATE_OPENMENU", payload});
export const createOpenSubMenuAction = (payload) => ({type: "UPDATE_OPENSUBMENU", payload});
export const createActiveState = (payload) => ({type:"UPDATE_ACTIVESTATE", payload});

export const SideMenuContextProvider = ({children}) => {
  const [state, dispatch] = useReducer(sideMenuReducer, initialState);

  return (
    <SideMenuContext.Provider value={{state, dispatch}}>
      {children}
    </SideMenuContext.Provider>
  );
};
